import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";

const YT_VIDEO_ID = "SUo4nBM8qx4";

export default function Formations() {
  return (
    <section
      className="relative min-h-screen pt-32 sm:pt-40 px-6 sm:px-10 lg:px-14 pb-24"
      data-testid="formations-page"
    >
      <SEO
        path="/formations"
        title="Formations"
        description="Formations — a cinematic live-performance platform built in New York City. Where music becomes cinema. Alex Soto (ALEKZ)."
      />
      <div className="max-w-5xl mx-auto">
        <h2
          className="font-display text-white leading-[0.95]"
          style={{ fontSize: "clamp(3rem, 9vw, 7rem)", letterSpacing: "-0.01em" }}
          data-testid="formations-title"
        >
          Formations
        </h2>

        <div className="mt-10 h-px bg-[var(--hairline-strong)] line-grow" />

        <div className="mt-14 max-w-3xl">
          <p
            className="font-display italic text-[var(--silver)] leading-[1.35]"
            style={{ fontSize: "clamp(1.4rem, 2.4vw, 2rem)" }}
            data-testid="formations-tagline"
          >
            A cinematic live-performance platform — where music becomes cinema.
          </p>
          <p className="mt-8 text-[var(--silver-soft)] text-sm sm:text-base leading-relaxed max-w-prose">
            Built in New York City, Formations crafts film-driven performance sessions with emerging and established artists. Each shoot is treated like a short film — its own world, set, light and narrative — captured 100% live.
          </p>

          <a
            href="https://www.formationsmedia.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="formations-external-link"
            className="silver-chip mt-12 inline-flex items-center gap-3 px-6 py-3 rounded-full font-mono-wide text-[10px] tracking-[0.5em]"
          >
            Visit formationsmedia.com
            <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </div>

        {/* First Formations film */}
        <div className="mt-20" data-testid="formations-film-section">
          <p className="font-mono-wide text-[10px] tracking-[0.4em] text-[var(--silver-soft)] mb-5">
            Film · I — First Formations Session
          </p>
          <div
            className="relative w-full overflow-hidden rounded-sm border border-[var(--hairline-strong)] bg-black"
            style={{ aspectRatio: "16 / 9", boxShadow: "var(--shadow-deep)" }}
          >
            <iframe
              data-testid="formations-youtube-embed"
              title="Formations — First Session"
              src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?rel=0&modestbranding=1`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="absolute inset-0 w-full h-full"
              style={{ border: 0 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
